import AnnualSurveyModal from 'src/components/AnnualSurveyModal.svelte';
import { PROMOTIONS } from 'src/constants';

export const AnnualSurvey2026Config = () => ({
	id: 'annualSurvey2026',
	component: AnnualSurveyModal,
	props: {
		showModal: true,
	},
	rules: [
		{
			check: () => {
				const now = new Date().getTime();
				return (
					now >= PROMOTIONS.ANNUAL_SURVEY_2026.START_DATE &&
					now < PROMOTIONS.ANNUAL_SURVEY_2026.END_DATE
				);
			},
			expected: true,
		},
	],
});
